import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const BillingContext = createContext(null);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);
  const [billingLoading, setBillingLoading] = useState(true);

  const userId = user?.id ?? null;

  const refreshBilling = useCallback(async () => {
    if (!userId) {
      setBilling(null);
      setBillingLoading(false);
      return;
    }
    try {
      const r = await api.get("/billing/status");
      setBilling(r.data);
    } catch {
    } finally {
      setBillingLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    setBillingLoading(true);
    refreshBilling();
  }, [userId]);
  
  return (
    <BillingContext.Provider
      value={{ billing, billingLoading, refreshBilling }}>
      {children}
    </BillingContext.Provider>
  );
}

export function useBilling() {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error("useBilling must be used inside BillingProvider");
  return ctx;
}
